 import GalleryBanner from "./Gallerybanner";
 import GallerySection from "./GallerySection";
 import React  from "react";

 const Gallery = () =>{
  return(
    <>
    <GalleryBanner />
    <GallerySection />
    </>
  )
 }

 export default Gallery;

